var toggleChatBotClasses = '.wc-chatbot-image, .wc-chatbot-image-mobile, .chatbot-close';
var toggleChatBotClassesToHide = '.chatbot-close, .wc-message-pane-wrapper, .wc-header';

$(document).ready(function () {
    $('.wc-chatbot-image-mobile').on('click', function () {
       $(toggleChatBotClassesToHide).fadeToggle();
    });

    $('.wc-chatbot-image').on('click', function () {
        $(toggleChatBotClassesToHide).fadeToggle();
    });

    $('.chatbot-close').on('click', function () {   
        $(toggleChatBotClassesToHide).fadeToggle();
    });
});

$(window).on('load', function () {

    var chatPanel = $('.wc-chatview-panel');
    var textBox = $('.wc-shellinput');
    var sendButton = $('.wc-send');
    var stickyClass = 'sticky-top';
    var messageGroupID = 'wc-message-groups';

    var messageGroup = $('.wc-message-group-content');
    var messageWrapperClass ='wc-message-wrapper';

    var messageGroupChildren = messageGroup.children('.' + messageWrapperClass);



    var botChatPanel = $('.wc-message-pane');
    var botGreeting = $('.wc-message-greeting');

 
    var timeToShow = chatPanel.data('timeToShow') * 1000; // convert seconds to milliseconds
    setTimeout(function () {
        $(toggleChatBotClassesToHide).hide();
        chatPanel.fadeIn("slow");
    }, timeToShow);

    if (window.location.pathname == '/') {
        $(window).bind('scroll load resize', function () {

            var height = $(window).scrollTop();
            var width = $(window).width();

            if (height == 0) {
                if (width >= 1100) {
                    chatPanel.removeClass(stickyClass);
                }
                else {
                    chatPanel.addClass(stickyClass);
                }
            }
            else {
                chatPanel.addClass(stickyClass);
            }
            
        });
    }
    else {
        chatPanel.addClass(stickyClass);
    }

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {

        $(textBox).focus(function () {

            $(window).each(function () {
                $(this).data('events', $.extend(true, {}, $._data(this, 'events')));
            });

            $(window).off("resize");
        }).focusout(function () {
            $(window).on("resize");

            $(window).each(function () {
                var $self = $(this);
                $.each($(this).data('events'), function (_, e) {
                    $self.on(e[0].type, e[0].handler);
                });
            });

        })
        .blur(function () {
            $(window).on("resize");

            $(window).each(function () {
                var $self = $(this);
                $.each($(this).data('events'), function (_, e) {
                    $self.on(e[0].type, e[0].handler);
                });
            });
         });
    }

    textBox.keypress(function (e) {
        if (e.which == 13) {
            sendButton.click();
        }
    });


    function CreateResponseHTML(response) {
        return "<div class=\"" + messageWrapperClass + " list\"><div class=\"wc-message wc-message-from-bot\"><div class=\"wc-message-content\"><svg class=\"wc-message-callout\"><path class=\"point-left\" d=\"m0,6 l6 6 v-12 z\"></path><path class=\"point-right\" d=\"m6,6 l-6 6 v-12 z\"></path></svg><div><div class=\"format-markdown\">" + response + "</div></div></div></div><div class=\"wc-message-from wc-message-from-bot\"><span>Bobby</span></div></div>";
    }

    function ScrollToChatPosition() {
        var parentDiv = document.getElementById(messageGroupID);
        var objDiv = messageGroupChildren.last();
        var scrollBottom = $(parentDiv).scrollTop() + $(parentDiv).height();

        $(parentDiv).animate({ scrollTop: parentDiv.scrollHeight }, 1000);

    }

    sendButton.on('click', function () {

        var questionText = textBox.val();
        textBox.val("");

        var html = "<div class=\"" + messageWrapperClass + " list\"><div class=\"wc-message wc-message-from-me\"><div class=\"wc-message-content\"><svg class=\"wc-message-callout\"><path class=\"point-left\" d=\"m0,6 l6 6 v-12 z\"></path><path class=\"point-right\" d=\"m6,6 l-6 6 v-12 z\"></path></svg><div><span class=\"format-plain\"><span>" + questionText + "<br></span></span></div></div></div><div class=\"wc-message-from wc-message-from-me\"><span>You</span></div></div>";

        messageGroup.append(html);

        ScrollToChatPosition();
        botChatPanel.show();
        botGreeting.hide();

        if (!chatPanel.hasClass('full-size'))
            chatPanel.addClass('full-size');

        $.ajax({
            url: "/WebServices/ChatBot.asmx/AskQuestion",
            type: "POST",
            data: "{'questionText' : '" + questionText + "'}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {

                var replyHTML = CreateResponseHTML(data.d.Answers[0].Answer)
                messageGroup.append(replyHTML);
                ScrollToChatPosition();

            },
            error: function () {
                var replyHTML = CreateResponseHTML("Sorry, Bobby is currently unavailable, please try again later");
                messageGroup.append(replyHTML);
                ScrollToChatPosition();
            }
        });
    });
});